import React from 'react';
import { ShieldCheck, Lock, CreditCard, FileText, Zap, BookOpen } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-[#0369A1] text-white min-h-[100svh] flex flex-col justify-center px-4 py-5 md:py-12 relative overflow-hidden" data-id="element-160">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center w-full" data-id="element-161">
        <span className="inline-block bg-white/10 px-3 py-1 rounded-full text-[11px] md:text-sm font-semibold tracking-wider text-[#F97316] uppercase mb-3 md:mb-6" data-id="element-162">
          PROFE LISTO · HOCKEY 360
        </span>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-3xl sm:text-4xl md:text-7xl font-bold text-[#F97316] mb-3 md:mb-6 leading-[1.05] uppercase tracking-wide" data-id="element-163">
          Todo tu año de hockey resuelto de una vez.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="w-full flex justify-center mb-3 md:mb-6" data-id="element-164">
          <img src="https://cdn.magicpatterns.com/uploads/jXtXFLsReoT5YfWvSXvCSj/397.png" alt="Megapack HOCKEY 360 — Pack Elite Completo" width={1080} height={1350} decoding="async" fetchPriority="high" className="max-h-[30vh] md:max-h-none md:w-full md:max-w-md w-auto object-contain drop-shadow-2xl" data-id="element-165" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-base sm:text-lg md:text-2xl text-white/90 max-w-3xl mx-auto mb-3 md:mb-6 font-medium leading-snug" data-id="element-166">
          Megapack HOCKEY 360 — Pack Anual Elite Completo
          <span className="hidden sm:block text-sm md:text-xl font-normal mt-1 md:mt-2 opacity-80" data-id="element-167">
            El sistema completo de ejercicios, planificación y táctica para el
            entrenador de hockey argentino.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="flex flex-col items-center w-full" data-id="element-168">
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-3 md:mb-6" data-id="element-169">
            <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1.5 rounded-lg text-xs md:text-base" data-id="element-170">
              <FileText className="w-4 h-4 md:w-5 md:h-5 text-[#F97316]" data-id="element-171" />
              <span className="font-medium" data-id="element-172">PDF</span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1.5 rounded-lg text-xs md:text-base" data-id="element-173">
              <Zap className="w-4 h-4 md:w-5 md:h-5 text-[#F97316]" data-id="element-174" />
              <span className="font-medium" data-id="element-175">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1.5 rounded-lg text-xs md:text-base" data-id="element-176">
              <BookOpen className="w-4 h-4 md:w-5 md:h-5 text-[#F97316]" data-id="element-177" />
              <span className="font-medium" data-id="element-178">16 Tomos + 6 Bonus + 2 Élite</span>
            </div>
          </div>

          <a href="#precio" className="w-full md:w-auto text-center bg-[#F97316] hover:bg-[#EA580C] text-white font-bold text-lg md:text-xl px-8 py-4 md:py-5 rounded-xl shadow-[0_0_30px_rgba(249,115,22,0.35)] transition-all hover:scale-105 active:scale-95 uppercase tracking-wide" data-id="element-179">
            🏑 QUIERO MI HOCKEY 360 AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mt-3 md:mt-6 text-[11px] md:text-sm text-white/80" data-id="element-180">
            <div className="flex items-center gap-1.5" data-id="element-181">
              <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#F97316]" data-id="element-182" />
              <span data-id="element-183">Garantía 7 días</span>
            </div>
            <span className="hidden md:inline text-white/30" data-id="element-184">|</span>
            <div className="flex items-center gap-1.5" data-id="element-185">
              <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#F97316]" data-id="element-186" />
              <span data-id="element-187">Pago seguro</span>
            </div>
            <span className="hidden md:inline text-white/30" data-id="element-188">|</span>
            <div className="flex items-center gap-1.5" data-id="element-189">
              <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#F97316]" data-id="element-190" />
              <span data-id="element-191">Tarjetas y transferencia</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}